export const createBlockId = () => `block-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const BLOCK_TYPES = [
  { type: "intro", label: "Introductie" },
  { type: "paragraph", label: "Paragraaf" },
  { type: "heading", label: "Tussenkop" },
  { type: "quote", label: "Quote" },
  { type: "insight", label: "Belangrijk inzicht" },
  { type: "warning", label: "Waarschuwing" },
  { type: "info", label: "Informatieblok" },
  { type: "impact", label: "Impactblok" },
  { type: "cards", label: "Cards" },
  { type: "list", label: "Lijst" },
  { type: "image", label: "Afbeelding" },
  { type: "mediaText", label: "Afbeelding + tekst" },
  { type: "video", label: "Video" },
  { type: "divider", label: "Divider" },
  { type: "cta", label: "CTA" },
  { type: "sources", label: "Bronnen" },
  { type: "downloads", label: "Downloads" },
  { type: "faq", label: "FAQ" },
  { type: "author", label: "Auteurblok" }
];

export const normalizeUrl = (value = "") => {
  const url = value.trim();
  if (!url) return "";
  return /^https?:\/\//i.test(url) || url.startsWith("/") ? url : "";
};

export const createBlock = (type = "paragraph") => {
  const base = { id: createBlockId(), type, hidden: false };
  switch (type) {
    case "intro":
      return { ...base, text: "Schrijf hier een korte, krachtige introductie." };
    case "heading":
      return { ...base, level: 2, text: "Nieuwe tussenkop" };
    case "quote":
      return { ...base, text: "Een citaat of belangrijk signaal.", attribution: "" };
    case "insight":
      return { ...base, title: "Belangrijk inzicht", text: "Waarom dit ertoe doet." };
    case "warning":
      return { ...base, title: "Let op", text: "Gebruik dit blok voor zorgvuldige medische of organisatorische nuance." };
    case "info":
      return { ...base, title: "Goed om te weten", text: "Praktische informatie of tip." };
    case "impact":
      return { ...base, title: "Waarom dit belangrijk is voor Rumah Kasih", text: "Leg de impact voor deelnemers, mantelzorgers of partners uit." };
    case "cards":
      return { ...base, columns: 3, items: [{ title: "Taal", text: "Moedertaal en vertrouwde woorden.", icon: "T" }] };
    case "list":
      return { ...base, ordered: false, items: ["Eerste punt", "Tweede punt"] };
    case "image":
      return { ...base, url: "", alt: "", caption: "", credit: "" };
    case "mediaText":
      return { ...base, imageUrl: "", alt: "", title: "Titel", text: "Tekst naast de afbeelding.", imagePosition: "left" };
    case "video":
      return { ...base, url: "", title: "" };
    case "divider":
      return base;
    case "cta":
      return { ...base, title: "Help Rumah Kasih verder", text: "Neem contact op of steun de opstart.", label: "Neem contact op", url: "/contact" };
    case "sources":
      return { ...base, items: [{ title: "Bron", description: "", website: "", date: "", url: "" }] };
    case "downloads":
      return { ...base, items: [{ title: "Download", fileType: "PDF", url: "" }] };
    case "faq":
      return { ...base, items: [{ question: "Vraag", answer: "Antwoord" }] };
    case "author":
      return { ...base, name: "Redactie Rumah Kasih", role: "", photo: "", bio: "" };
    default:
      return { ...base, type: "paragraph", text: "Nieuwe paragraaf." };
  }
};

export const normalizeBlocks = (blocks = []) => {
  if (!Array.isArray(blocks)) return [];
  return blocks
    .filter(block => block && typeof block === "object" && typeof block.type === "string")
    .map(block => ({ ...block, id: block.id || createBlockId(), hidden: block.hidden === true }));
};

export const blocksFromPlainText = (body = "") => {
  const blocks = body.split(/\n{2,}/).map(block => block.trim()).filter(Boolean).map(block => {
    if (block.startsWith("### ")) return { ...createBlock("heading"), level: 3, text: block.replace(/^### /, "") };
    if (block.startsWith("## ")) return { ...createBlock("heading"), level: 2, text: block.replace(/^## /, "") };
    if (block.startsWith("> ")) return { ...createBlock("quote"), text: block.replace(/^> /, "") };
    return { ...createBlock("paragraph"), text: block };
  });
  return normalizeBlocks(blocks);
};
